const TOKEN = localStorage.getItem('INX.TOKEN') || '';

export default {
    namespaced: true,
    state: {
        token: TOKEN,
    },
    actions: {},
    getters: {
        Token: state => {
            if (!state.token) {
                try {
                    state.token = localStorage.getItem('INX.TOKEN') || '';
                } catch (e) {
                    console.error(e);
                }
            }
            return state.key;
        },
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            localStorage.setItem('INX.TOKEN', token);
        },
        setLogout(state) {
            localStorage.setItem('INX.TOKEN', '');
            state.token = '';
        },
    },
};
